import { CssBaseline } from "@mui/material";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useLocation,
} from "react-router-dom";
import { Theme } from "./theme/Theme";
import Header from "./components/layout/Header";
import SidebarExpanded from "./components/layout/SidebarExpanded";
import SidebarCollapsed from "./components/layout/SidebarCollapsed";
import Signup from "./pages/Signup/Signup";
import Settings from "./pages/Settings/Settings";
import Login from "./pages/Login/Login";
import { useState, useRef } from "react";
import SearchResultsWithChat from "./features/search/pages/SearchResultsPage";
import SearchEntryScreen from "./features/search/pages/SearchEntryScreen";
import Company from "./pages/Company";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";

function App() {
  const [keyword, setKeyword] = useState<string>("");

  const sidebarOpenRef = useRef(true);
  const [, forceRender] = useState(false);

  const toggleSidebar = () => {
    sidebarOpenRef.current = !sidebarOpenRef.current;
    forceRender((v) => !v);
  };

  const location = useLocation();
  const hideSidebar = ["/login", "/signup"].includes(location.pathname);

  return (
    <Theme>
      <CssBaseline />
      <div className="h-screen flex flex-col overflow-hidden">
        <Header />
        <div className="flex flex-1 overflow-hidden pt-14">
          {!hideSidebar &&
            (sidebarOpenRef.current ? (
              <SidebarExpanded onToggle={toggleSidebar} />
            ) : (
              <SidebarCollapsed onToggle={toggleSidebar} />
            ))}

          <main
            className={`flex-1 overflow-auto transition-all duration-300 ${
              hideSidebar ? "" : sidebarOpenRef.current ? "ml-60" : "ml-14"
            }`}
          >
            <Routes>
              <Route
                path="/search-entry"
                element={<SearchEntryScreen keyword={keyword} setKeyword={setKeyword} />}
              />
              <Route
                path="/search-results"
                element={<SearchResultsWithChat keyword={keyword} setKeyword={setKeyword} />}
              />
              <Route path="/settings" element={<Settings />} />
              <Route path="/" element={<Navigate to="/search-entry" />} />
              <Route path="/signup" element={<Signup />} />
              <Route path="/login" element={<Login />} />
              <Route path="/company" element={<Company />} />
              <Route path="/terms" element={<Terms />} />
              <Route path="/privacy" element={<Privacy />} />
            </Routes>
          </main>
        </div>
      </div>
    </Theme>
  );
}

export default function AppWrapper() {
  return (
    <Router>
      <App />
    </Router>
  );
}
